// Layar pelanggan kasir web: pembuat pesan yang dikirim ke server (lihat layarServer.js). Tampilannya SATU halaman untuk web &
// Flutter, yaitu /layar di server (backend public/layar/index.html); nama/logo cabang diisi server dari sesi kasir.
const angka = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

/** Info cabang (opsional; server memakai data cabang dari sesi kasir). */
export const infoCabang = ({ nama, logo, sambutan } = {}) => ({ nama: nama || '', logo: logo || '', sambutan: sambutan || '' });

/**
 * Pesan isi keranjang. items: [{ nama, harga, qty, grosir?, catatan?, opsi? }]; total = tagihan akhir (setelah promo & PPN).
 * Keranjang kosong -> pesan 'kosong'.
 */
export const pesanKeranjang = ({ items = [], subtotal, diskon = 0, promoNama = '', ppnPersen = 0, ppnNominal = 0, total }, cabang) => {
  const baris = items
    .filter((i) => angka(i.qty) > 0)
    .map((i) => ({ nama: String(i.nama || ''), harga: angka(i.harga), qty: angka(i.qty), grosir: !!i.grosir, catatan: i.catatan || '', opsi: i.opsi || '' }));
  if (baris.length === 0) return { tipe: 'kosong', cabang };
  const hitungSubtotal = baris.reduce((a, i) => a + i.harga * i.qty, 0);
  return {
    tipe: 'keranjang',
    cabang,
    items: baris,
    subtotal: subtotal === undefined ? hitungSubtotal : angka(subtotal),
    diskon: angka(diskon),
    promoNama: promoNama || '',
    ppnPersen: angka(ppnPersen),
    ppnNominal: angka(ppnNominal),
    total: total === undefined ? hitungSubtotal - angka(diskon) + angka(ppnNominal) : angka(total),
  };
};

/** Pesan QRIS: pelanggan memindai QR di layar. qris = { url, qrString, isProduction }; server menggambar QR dari qrString. */
export const pesanQris = ({ qris, total }, cabang) => ({ tipe: 'qris', cabang, qris: qris || null, total: angka(total) });

/** Pesan transaksi selesai. kembalian > 0 hanya untuk tunai. */
export const pesanSelesai = ({ total, bayar = 0, kembalian = 0, metode = '', nomorAntrian = '' }, cabang) => ({
  tipe: 'selesai', cabang, total: angka(total), bayar: angka(bayar), kembalian: Math.max(0, angka(kembalian)), metode: String(metode || ''), nomorAntrian: String(nomorAntrian || ''),
});

/**
 * Penahan layar "terima kasih" di sisi kasir: keranjang yang sama dengan saat transaksi selesai (belum dikosongkan) tidak boleh
 * dikirim lagi, supaya tidak menimpa "terima kasih". Pesan 'kosong' atau keranjang yang berbeda melepas penahan.
 * Mengembalikan fungsi saring(pesan) -> pesan yang boleh dikirim, atau null bila harus ditahan.
 */
export const buatPenahanSelesai = () => {
  let isiTerakhir = null; // keranjang/kosong terakhir sebelum selesai (QRIS tidak dihitung)
  let tanda = null;
  return (pesan) => {
    if (!pesan || typeof pesan !== 'object') return pesan;
    if (pesan.tipe === 'selesai') { tanda = isiTerakhir; return pesan; }
    const sidik = JSON.stringify(pesan);
    if (tanda !== null && pesan.tipe === 'keranjang' && sidik === tanda) return null;
    tanda = null;
    if (pesan.tipe === 'keranjang' || pesan.tipe === 'kosong') isiTerakhir = sidik;
    return pesan;
  };
};

/**
 * Alamat halaman layar. `ganti` (REACT_APP_LAYAR_URL) bila diisi; bila host API berawalan `api.` -> subdomain `layar.` dengan
 * domain yang sama (https://api.contoh.com -> https://layar.contoh.com); selain itu `<alamat API>/layar`
 * (pengembangan lokal: http://localhost:5000/layar). Aturan sama dengan aplikasi Flutter.
 */
export const alamatLayar = (alamatApi, ganti = '') => {
  const manual = String(ganti || '').trim().replace(/\/+$/, '');
  if (manual) return manual;
  try {
    const u = new URL(alamatApi);
    if (/^api\./i.test(u.hostname)) return `${u.protocol}//layar.${u.hostname.slice(4)}${u.port ? `:${u.port}` : ''}`;
  } catch (e) { /* alamat tidak valid: pakai bawaan */ }
  return `${String(alamatApi).replace(/\/+$/, '')}/layar`;
};
